import React from "react";

const Heading = ({ text }) => {
  return (
    <h1 className="margin-bottom-sm text-center color-contrast-high margin-top-sm">
      {text}
    </h1>
  );
};

export default Heading;
